/**
 * Camada única de medição.
 *
 * - Meta Pixel (fbq) já é carregado em <MetaPixel />.
 * - Se existir window.dataLayer (GTM/GA4 no futuro), os mesmos eventos são enviados.
 * - Eventos declarativos: qualquer elemento com data-track="<evento>" e
 *   data-track-label="<origem>" é medido por <AnalyticsClicks /> sem JS extra.
 */

export const META_PIXEL_ID =
  process.env.NEXT_PUBLIC_META_PIXEL_ID ?? "1425902539098496";

export type TrackEvent =
  | "contact_click"
  | "partner_click"
  | "form_submit"
  | "download"
  | "video_play"
  | "segment_select";

type Params = Record<string, string | number | boolean | undefined>;

// Mapeamento para o vocabulário do Meta (eventos padrão quando existe um equivalente)
const META_EVENTS: Record<
  TrackEvent,
  { kind: "track" | "trackCustom"; name: string }
> = {
  contact_click: { kind: "track", name: "Contact" },
  partner_click: { kind: "trackCustom", name: "PartnerClick" },
  form_submit: { kind: "track", name: "Lead" },
  download: { kind: "trackCustom", name: "Download" },
  video_play: { kind: "trackCustom", name: "VideoPlay" },
  segment_select: { kind: "trackCustom", name: "SegmentSelect" },
};

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
    dataLayer?: unknown[];
  }
}

export function track(event: TrackEvent, params: Params = {}) {
  if (typeof window === "undefined") return;

  const meta = META_EVENTS[event];
  const sendToMeta = (attempt: number) => {
    if (typeof window.fbq === "function") {
      window.fbq(meta.kind, meta.name, params);
    } else if (attempt < 6) {
      // O pixel carrega depois da interação inicial: tenta novamente em breve.
      window.setTimeout(() => sendToMeta(attempt + 1), 800);
    }
  };
  sendToMeta(0);

  window.dataLayer?.push({ event, ...params });
}
